import { casamapaAdminPortalPath } from "./casamapaAdminPortalPaths.js";

/** Admin portal segments for vendor directory workspace (Spanish paths match workspace API). */
export const CASAMAPA_ADMIN_VENDOR_SECTIONS = {
  vendors: "proveedores",
  vendorCreate: "proveedores/nuevo",
  candidates: "candidatos",
  imports: "importaciones",
  duplicates: "duplicados",
  sources: "fuentes",
  collectionPlans: "colecciones/planes",
  collectionRuns: "colecciones/ejecuciones",
  verification: "verificacion",
  credentials: "credenciales",
  claims: "reclamaciones",
  privacy: "privacidad",
  privacyRetention: "privacidad/retencion",
  ranking: "posicionamiento",
  analytics: "analytics",
  maintenance: "mantenimiento",
  pilot: "piloto",
  expansion: "expansion",
  marketplace: "marketplace",
  settings: "configuracion",
};

export function casamapaAdminVendorHubPath(clientViewId, segment = "") {
  if (!clientViewId) {
    return casamapaAdminPortalPath("vendors");
  }
  const base = casamapaAdminPortalPath(`vendors/workspace/${clientViewId}`);
  if (!segment) return base;
  const normalized = String(segment).replace(/^\/+|\/+$/g, "");
  return normalized ? `${base}/${normalized}` : base;
}

export function casamapaAdminVendorPath(segment = "") {
  return casamapaAdminPortalPath(segment ? `vendors/${segment}` : "vendors");
}

export function casamapaAdminVendorManagePath(clientViewId, vendorId) {
  return casamapaAdminVendorHubPath(clientViewId, `proveedores/${vendorId}`);
}

export { casamapaVendorPublicProfilePath } from "./casamapaVendorWorkspacePaths.js";
